module.exports = __webpack_public_path__ + "img/img_tongguo@3x.a56741eb.png";